import React, { Component } from 'react'
import { Card, Form, Row, Image, Button, Collapse } from 'react-bootstrap';
import { FaPencilAlt, FaRegWindowClose, FaPlus, FaMinus } from 'react-icons/fa';
import { isNullOrUndefined } from 'util';
import { connect } from 'react-redux';
import { pollOperations } from './state';
import { withRouter } from "react-router";
import { bindActionCreators } from 'redux';
import { MODE_ADD, MODE_EDIT, POLL_DEFAULT_IMAGE, SECONDARY, CANCEL, SUCCESS_BUTTON, SAVE, MAXNUMBER_OF_CHOICES, CHOICES, VOTES, IDX, SUPER_ADMIN, ADD_MANUALVOTES} from '../../../utils/constants';
import { REST_SERVICE_URL_ROOT } from '../../../config/settings';
import { ADD_MANUAL_VOTE_ROUTE } from './routes';


class PollElectionResult extends Component {

    constructor(props) {
        super(props)
        this.state = {
            currentChoiceList: null,
            activeSelection: null,
            activeChoice: null,
            selectionList: [],
            choiceList: [],
            pollDetails: props.pollDetails,
            emptyFlag: false,
            currentSelection: props.selections,
            openModal: false,
            imageFile: null,
            mode: props.mode,
            initialCandidateDetails: null,
            selectionId: 0,
            pollSelectionChoiceDetails: [],
            imageHash: Date.now(),
            choiceId: 0,
            imageError: false,
            showCollapse: true
        }
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            selectionList: newProps.selections,
            pollDetails: newProps.pollDetails,
            currentSelection: newProps.selections,
            mode: newProps.mode
        })
    }

    toggle = () => {
        this.setState({
            showCollapse: !this.state.showCollapse
        })
    }

    renderButtons = () => {

        switch (this.state.mode) {
            case MODE_ADD: {
                return [
                    { variant: SECONDARY, label: CANCEL, icon: FaRegWindowClose, onClick: this.closeModal },
                    { variant: SUCCESS_BUTTON, label: SAVE, icon: FaPencilAlt, onClick: this.onSubmitClick }
                ]
            }
            case MODE_EDIT: {
                return [
                    { variant: SECONDARY, label: CANCEL, icon: FaRegWindowClose, onClick: this.closeModal },
                    { variant: SUCCESS_BUTTON, label: SAVE, icon: FaPencilAlt, onClick: this.onSubmitClick }
                ]
            }
            default: { return []}
        }
    }


    addManualVotes = () => {

        let pollDetails = this.state.pollDetails
        let selection = this.state.currentSelection
        this.props.history.push({
            pathname: ADD_MANUAL_VOTE_ROUTE + `/${pollDetails.pollId}`,
            state: selection
        })
    }



    render() {
        let selection = this.state.currentSelection
        let user = this.props.isAuthenticated

        return (
            <div>

                {IDX === this.props.idx &&
                    SUPER_ADMIN === user.credentials.accessRights &&
                    <Button onClick={this.addManualVotes} disabled={0 === this.state.selectionList.length}>
                        <FaPlus /> {ADD_MANUALVOTES}
                        </Button>


                }
                <Card className="card-collapse">
                    <Card.Header className="text-white" style={{ backgroundColor: 'var(--primaryColor)' }}>{selection.selectionTitle}{this.state.showCollapse ? <FaMinus className="toggle-button" onClick={() => this.toggle()} /> : <FaPlus className="toggle-button" onClick={() => this.toggle()} />}</Card.Header>
                    <Collapse in={this.state.showCollapse}>
                        <Card.Body>
                            <span style={{ fontSize: '14px' }}>{MAXNUMBER_OF_CHOICES}</span> <br />
                            <b style={{ marginLeft: '30px' }}>{selection.numChoices}</b> <br />
                            <span style={{ marginTop: '30px' }}>{CHOICES}</span> <br />

                            {!isNullOrUndefined(selection.choiceListWithResult) && selection.choiceListWithResult.map((data, i) => {
                                return (
                                    <div key={i} style={{ marginTop: '10px' }}>
                                        <Row key={i} style={{ marginLeft: '0px' }}>
                                            <Image
                                                roundedCircle
                                                src={`${REST_SERVICE_URL_ROOT}/poll/image/choice/${data.pollSelectionChoiceModel.choiceId}?${new Date()}`}
                                                className="candidate-image"
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = {POLL_DEFAULT_IMAGE}
                                                }}
                                            />
                                            <Form.Control value={data.pollSelectionChoiceModel.choiceLabel} data-item={i} name="choiceLabel" disabled={true} style={{ width: '30%' }} className="input-candidate"></Form.Control>
                                            <span className="vote-count"><b> {data.resultCount} {VOTES}</b></span>
                                        </Row>

                                    </div>
                                )
                            })}
                        </Card.Body>
                    </Collapse>
                </Card>
            </div >
        )
    }

}

const mapStateToProps = (state) => {
    return {
        pollForm: state.polls.pollForm,
        selectInput: state.polls.selectInput,
        poll: state.polls.poll,
        candidateForm: state.polls.candidateForm,
        isAuthenticated: state.auth
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        insertPollSelectionChoice: pollOperations.insertPollSelectionChoice,
        updatePollSelectionChoice: pollOperations.updatePollSelectionChoice,
        deletePollSelection: pollOperations.deletePollSelection,
        deletePollSelectionChoice: pollOperations.deletePollSelectionChoice
    },
    dispatch
)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PollElectionResult));